
<template>
  <div id="download-wrapper">
    <div class="download-main">
      <head-bar />
      <main-bar />
      <foot-bar />
    </div>
    <div class="download-bottom-grass">
      <img src="//yy-s.zuoyebang.cc/zuoyebang/stuwin/images/grass.png" alt="" />
    </div>
    <div class="download-top-cloud">
      <img src="//yy-s.zuoyebang.cc/zuoyebang/stuwin/images/cloud.png" alt="" />
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import HeadBar from "./components/headbar.vue";
import MainBar from "./components/main.vue";
import FootBar from "./components/footbar.vue";

export default {
  name: "StuWin",
  components: {
    HeadBar,
    FootBar,
    MainBar,
  },
  mounted() {
    document.addEventListener("DOMContentLoaded", () => {
      new Image().src =
        "https://notice.zuoyebang.cc/napi/stat/addnoticev1?name=EXE_STU_ENTER&type=pv";
    });
  },
};
</script>
<style lang="less">
@font-face {
  font-family: "iconfont"; /* project id 398513 */
  src: url("//at.alicdn.com/t/font_398513_iwfzgpbqpz.eot");
  src: url("//at.alicdn.com/t/font_398513_iwfzgpbqpz.eot?#iefix")
      format("embedded-opentype"),
    url("//at.alicdn.com/t/font_398513_iwfzgpbqpz.ttf") format("truetype"),
    url("//at.alicdn.com/t/font_398513_iwfzgpbqpz.woff") format("woff"),
    url("//at.alicdn.com/t/font_398513_iwfzgpbqpz.svg#iconfont") format("svg");
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
}

html,
body {
  height: 100%;
}

body {
  background: #fff;
  min-width: 1010px;
}
.download-clearfix {
  clear: both;
}

.download-block {
  width: 100%;
  display: block;
}

#download-wrapper {
  position: relative;
  height: 100%;
  background: linear-gradient(180deg, #c6f9eb 0%, #adf0dd 100%);
  overflow-x: hidden;
  #floating {
    position: absolute;
    z-index: 0;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .download-main {
    position: relative;
    z-index: 1;
    width: 1080px;
    height: 100%;
    margin: 0 auto;
  }

  .download-bottom-grass {
    position: fixed;
    z-index: 0;
    left: 0;
    bottom: 0;
  }

  .download-bottom-grass img {
    width: 100%;
    display: block;
  }
  .download-top-cloud {
    position: fixed;
    z-index: 0;
    left: 0;
    top: 50px;
  }

  .download-top-cloud img {
    width: 100%;
    display: block;
  }
}

@media screen and (max-width: 1269px) {
  #download-wrapper {
    .download-main {
      width: 800px;
      .download-main-logo {
        padding: 25px 0;
        .logo-img {
          // width: 195px;
          height: 39px;
        }
        .logo-type {
          line-height: 29px;
          font-size: 15px;
        }
      }

      .download-main-content {
        &.download-main-middle {
          min-height: 380px;
        }
        .download-machine {
          width: 433px;
          margin-right: 0;
        }
      }
    }
  }
}

@media screen and (min-width: 1270px) {
  #download-wrapper .download-main {
    width: 1120px;
    .download-main-logo {
      padding: 25px 0;
    }

    .download-main-logo .logo-img {
      // width: 195px;
      height: 39px;
    }

    .download-main-logo .logo-type {
      line-height: 38px;
      font-size: 20px;
    }

    .download-main-content {
      .download-machine {
        width: 520px;
      }
    }
    .download-main-middle {
      min-height: 380px;
    }
  }
}

@media screen and (min-width: 1350px) {
  #download-wrapper .download-main {
    width: 1140px;

    .download-main-logo {
      padding: 34px 0 24px;
    }

    .download-main-logo .logo-img {
      // width: 195px;
      height: 39px;
    }

    .download-main-logo .logo-type {
      line-height: 41px;
      font-size: 21px;
    }

    .download-main-content .download-machine {
      width: 600px;
    }
    .fade-list {
      margin-bottom: 12px;
    }
    .download-main-middle {
      min-height: 390px;
    }
  }
}

@media screen and (min-width: 1400px) {
  #download-wrapper .download-main {
    .download-main-logo {
      padding: 61.6px 0;
    }
    .download-main-content .download-machine {
      width: 599px;
    }
  }
}

@media screen and (min-width: 1580px) {
  #download-wrapper .download-main {
    width: 1200px;
    .download-main-middle {
      min-height: 440px;
    }
  }

  #download-wrapper .download-main .download-main-logo {
    padding: 38px 0;
  }

  #download-wrapper .download-main .download-main-logo .logo-img {
    // width: 195px;
    height: 39px;
  }

  #download-wrapper .download-main .download-main-logo .logo-type {
    line-height: 48px;
    font-size: 25px;
  }

  #download-wrapper .download-main .download-main-content .download-machine {
    width: 700px;
  }
  #download-wrapper
    .download-main
    .download-main-content
    .download-main-content-download {
    margin-top: 50px;
  }
}

@media screen and (min-width: 1680px) {
  #download-wrapper .download-main .download-main-logo {
    padding: 76.6px 0;
  }
}

@media screen and (min-width: 1910px) {
  #download-wrapper .download-main {
    width: 1400px;
    .download-main-middle {
      min-height: 505px;
    }
  }

  #download-wrapper .download-main .download-main-logo {
    padding: 60px 0;
  }

  #download-wrapper .download-main .download-main-logo .logo-img {
    // width: 195px;
    height: 39px;
  }

  #download-wrapper .download-main .download-main-logo .logo-type {
    line-height: 57px;
    font-size: 30px;
  }

  #download-wrapper .download-main .download-main-content .download-machine {
    width: 830px;
  }

  #download-wrapper
    .download-main
    .download-main-content
    .download-main-content-download {
    padding-top: 70px;
  }
  #download-wrapper .download-main-footer {
    width: 100%;
    position: absolute;
    bottom: 20px;
  }
}
</style>
